import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { MovieContentSubtype } from "../../../types/MovieContentSubtype";
import { GetMovieByIdResponse } from "./GetMovieByIdResponse";
import { SearchMoviesRequest } from "./SearchMoviesRequest";
import { SearchMoviesResponse } from "./SearchMoviesResponse";
import { SuggestMovieByTitleResponse } from "./SuggestMovieByTitleResponse";

export const useCatalogueMovieApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const { httpGet, httpPost } = useAuthorizedFetch();
    const baseUrl = `${appConfigContext.catalogueConfig.apiUrl}/movies/search`;

    const suggestMovieByTitle = async (
        title: string,
        contentType: MovieContentSubtype
    ): Promise<SuggestMovieByTitleResponse> => {
        return httpGet<SuggestMovieByTitleResponse>(`${baseUrl}/suggest`, {
            title,
            subtype: contentType
        });
    };

    const searchMovies = async (request: SearchMoviesRequest): Promise<SearchMoviesResponse> => {
        return httpPost<SearchMoviesResponse>(`${baseUrl}`, request);
    };

    const getMovieById = async (movieId: string): Promise<GetMovieByIdResponse> => {
        return httpGet<GetMovieByIdResponse>(`${baseUrl}/${movieId}`);
    };

    return {
        suggestMovieByTitle,
        searchMovies,
        getMovieById
    };
};
